import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({
  theme: {
    tokens: {
      fonts: {
        body: { value: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
        mono: { value: "'JetBrains Mono', 'SFMono-Regular', Consolas, monospace" },
      },
      radii: {
        l1: { value: "2px" },
        l2: { value: "4px" },
        l3: { value: "4px" },
        panel: { value: "4px" },
      },
      colors: {
        brand: {
          50: { value: "#eef2ff" },
          100: { value: "#e0e7ff" },
          400: { value: "#818cf8" },
          500: { value: "#6366f1" },
          600: { value: "#4f46e5" },
          700: { value: "#4338ca" },
        },
      },
    },
    semanticTokens: {
      colors: {
        bg: {
          canvas: { value: { base: "#f6f7fb", _dark: "#090c11" } },
          panel: { value: { base: "#ffffff", _dark: "#10141b" } },
          subtle: { value: { base: "#f0f2f7", _dark: "#151a23" } },
          elevated: { value: { base: "#ffffff", _dark: "#191f2a" } },
        },
        fg: {
          default: { value: { base: "#111827", _dark: "#edf2f7" } },
          muted: { value: { base: "#667085", _dark: "#8c96a8" } },
          subtle: { value: { base: "#8b93a3", _dark: "#6f7a8d" } },
        },
        border: {
          default: { value: { base: "#dde2ea", _dark: "#252c38" } },
          subtle: { value: { base: "#edf0f4", _dark: "#1c222d" } },
        },
        status: {
          positive: { value: { base: "#15803d", _dark: "#34d399" } },
          negative: { value: { base: "#dc2626", _dark: "#fb7185" } },
          warning: { value: { base: "#b45309", _dark: "#fbbf24" } },
          info: { value: { base: "#1d4ed8", _dark: "#60a5fa" } },
        },
        trading: {
          long: { value: { base: "#15803d", _dark: "#34d399" } },
          short: { value: { base: "#dc2626", _dark: "#fb7185" } },
          paper: { value: { base: "#b45309", _dark: "#fbbf24" } },
          live: { value: { base: "#be123c", _dark: "#fb7185" } },
        },
        strategy: {
          predictive: { value: { base: "#7c3aed", _dark: "#a78bfa" } },
        },
      },
    },
  },
});

export const system = createSystem(defaultConfig, config);
